var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vac-tabs-menu"},[_c('div',{staticClass:"vac-tabs-menu__container"},_vm._l((_vm.tabs),function(tab,index){return _c('button',{key:`tab-${index}`,class:_setup.tabClasses(tab),on:{"click":function($event){return _setup.switchTab(index)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }